<div class="min-h-screen flex flex-col items-center justify-center bg-gray-50">
  <form
    class="bg-white p-8 rounded-xl shadow-md w-full max-w-md"
    [formGroup]="registerForm"
    (ngSubmit)="onSubmit()"
  >
    <h2 class="text-3xl font-bold text-gray-800 mb-8 text-center">Register</h2>
    <div class="mb-6">
      <label for="username" class="block text-gray-700 font-semibold mb-2"
        >Username</label
      >
      <input
        id="username"
        name="username"
        type="text"
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
        placeholder="Enter your username"
        formControlName="username"
        required
      />
    </div>
    <div class="mb-6">
      <label for="isEmployee" class="block text-gray-700 font-semibold mb-2"
        >Are you an employee?</label
      >
      <div class="flex items-center gap-4">
        <label class="flex items-center">
          <input
            id="isEmployeeYes"
            type="radio"
            name="isEmployee"
            value="yes"
            class="mr-2"
            [checked]="isEmployee"
            (change)="isEmployee = true; addEmployeeIdControl()"
          />
          Yes
        </label>
        <label class="flex items-center">
          <input
            id="isEmployeeNo"
            type="radio"
            name="isEmployee"
            value="no"
            class="mr-2"
            [checked]="!isEmployee"
            (change)="isEmployee = false; removeEmployeeIdControl()"
          />
          No
        </label>
      </div>
    </div>

    @if(registerForm.get("employeeId")){
    <div
      class="transition-all duration-300 ease-in-out overflow-hidden"
      [ngClass]="{
        'opacity-100 max-h-40 scale-100 mb-6 ': isEmployee,
        'opacity-0 max-h-0 scale-95 pointer-events-none mb-0': !isEmployee
      }"
    >
      <label for="employeeId" class="block text-gray-700 font-semibold mb-2"
        >Employee ID</label
      >
      <input
        id="employeeId"
        name="employeeId"
        type="number"
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
        placeholder="Enter your employee ID"
        [required]="isEmployee"
        formControlName="employeeId"
      />
    </div>

    }
    <div class="mb-6">
      <label for="password" class="block text-gray-700 font-semibold mb-2"
        >Password</label
      >
      <input
        id="password"
        name="password"
        type="password"
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
        placeholder="Enter your password"
        formControlName="password"
        required
      />
    </div>
    <div class="mb-6">
      <label for="password" class="block text-gray-700 font-semibold mb-2"
        >Confirm Password</label
      >
      <input
        id="password"
        name="password"
        type="password"
        formControlName="confirmPassword"
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
        placeholder="Re-enter your password"
        required
      />
    </div>

    @if(message()){
    <p class="mt-3">{{ message() }}</p>
    }

    <button
      type="submit"
      class="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 rounded-lg transition"
    >
      Register
    </button>
  </form>
  <p class="mt-4">
    Already a user?
    <a class="text-blue-600 hover:text-blue-800 underline" routerLink="/login"
      >Login Here</a
    >
  </p>
</div>
